import React from "react";
import { Field } from "redux-form/immutable";
import { Grid } from "@material-ui/core";

import TextField from "app/components/form/TextField";
import { EMPLOYEE_GROUP_FORM } from "features/planner/planner.constants";

const renderTextField = props => (
  <Field fullWidth margin="normal" component={TextField} {...props} />
);

const EmployeeGroupForm = ({ handleSubmit }) => {
  return (
    <form onSubmit={handleSubmit} id={EMPLOYEE_GROUP_FORM.ID}>
      <Grid container>
        <Grid item xs={12}>
          {renderTextField({
            label: "Name",
            required: true,
            autoFocus: true,
            name: EMPLOYEE_GROUP_FORM.NAME,
          })}
        </Grid>
      </Grid>
    </form>
  );
};

export default React.memo(EmployeeGroupForm);
